import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Service Cards',
  content: [
    'Service cards, available in specific provinces, provide access to government services, so it is important to',
    'replace it quickly if it has been lost or stolen. Follow the steps below to replace it:',

    '<h6>British Columbia</h6>',
    '<ul>',

    '<li>If you have a BC Services Card without a photo, report the loss immediately to Health Insurance BC at',
    '<a  href="tel:604-683-7151">604-683-7151</a> in Vancouver, <a  href="tel:+1-800-663-7100">1-800-663-7100</a>',
    'elsewhere in BC. Health Insurance BC will assist you in obtaining a replacement card.</li>',

    '<li>If you have a BC Services Card with a photo, and are between 19-75, report the loss at',
    '<a  href="tel:250-978-8300">250-978-8300</a> if you are in Victoria or at <a  href="tel:+1-800-950-1498">1-800-950-1498</a> elsewhere',
    'in B.C. You can get your replacement card by visiting the Insurance Corporation of British Columbia (ICBC) driver&#39;s licensing',
    'office nearest you.</li>',

    '</ul>',

    '<h6>Northwest Territories</h6>',
    '<ul>',
    '<li>Contact the Health Services Administration Office at <a  href="mailto:healthcarecard@gov.nt.ca">healthcarecard@gov.nt.ca</a>',
    'or by calling <a  href="tel:+1-867-777-7400">1-867-777-7400</a>',
    '(Inuvik) or <a  href="tel:+1-800-661-0830">1-800-661-0830</a> (toll free) to request a new card.</li>',
    '</ul>',

    '<h6>Nunavut</h6>',
    '<ul>',
    '<li>Contact the Health Insurance Programs Office in Rankin Inlet at <a  href="mailto:nhip@gov.nu.ca">nhip@gov.nu.ca</a>',
    'or by calling <a  href="tel:+1-867-645-8001">1-867-645-8001</a> or <a  href="tel:+1-800-661-0833">1-800-661-0833</a>',
    '(toll free) to request a replacement card.',
    '</ul>',

    '<h6>Yukon</h6>',
    '<ul>',
    '<li>Contact Insured Health Services at <a  href="tel:+1-867-667-5209">1-867-667-5209</a> to request a replacement card.</li>',
    '</ul>'
  ].join('\n')
};
